import { render, staticRenderFns } from "./address-field-group.vue?vue&type=template&id=059ed7b1&scoped=true"
import script from "./address-field-group.vue?vue&type=script&lang=ts"
export * from "./address-field-group.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059ed7b1",
  null
  
)

export default component.exports